import React, { useState, useEffect } from 'react';

import AsyncStorage from '@react-native-async-storage/async-storage';

import { DisplayContext, isAutoMode } from './options.context';
import { options } from './options.Enum';

const setDisplayOption = async setOption => {
  const value = await AsyncStorage.getItem('@display_option');
  if (value) {
    setOption(value);
  }
};

const withDisplayOptions = WrappedComponent => {
  const HocComponent = ({ ...props }) => {
    const [option, setOption] = useState(isAutoMode ? options.auto : options.light);
    useEffect(() => {
      setDisplayOption(setOption);
    }, []);
    const state = {
      option,
      changeTheme: themeOption => {
        setOption(themeOption);
        AsyncStorage.setItem('@display_option', themeOption);
      },
    };
    return (
      <DisplayContext.Provider value={state}>
        <WrappedComponent {...props} displayOption={option} />
      </DisplayContext.Provider>
    );
  };

  return HocComponent;
};

export default withDisplayOptions;
export { setDisplayOption };
